module.exports = __webpack_public_path__ + "static/media/item-view.b53cbb6f.jpg";